export const PHONE_REGEX = /^(?:\(\d{3}\)\s?|\d{3}[-\s]?)\d{3}[-\s]?\d{4}$/;

// Standard 17-character VIN (excludes I, O, Q) — matches legacy's validateVin exactly.
export const VIN_REGEX = /^[A-HJ-NPR-Za-hj-npr-z\d]{8}[\dX][A-HJ-NPR-Za-hj-npr-z\d]{2}\d{6}$/;

export const POSTAL_CODE_REGEX = /(^\d{5}$)|(^\d{5} - \d{4}$)/;

export const DIGITS_ONLY_REGEX = /^\d+$/;

export const LEADING_COMMA_REGEX = /^, /;
